import history from 'lib/history';

import { getStore } from 'store';
import parseAccountInfo from 'lib/parseAccountInfo';
import gigya from 'api/gigya';
import { login, updateProfile, showTalpaGigyaModal, setUserHDPreference, logout } from 'actions/gigya-actions';
import { setModalStandaloneOpen } from 'actions/modal-actions';
import { setBodyScroll, removeHash, onVendorLoaded, logger } from 'util/index';

import { GIGYA_SCREENSET, GIGYA_ACCOUNT_ACTION } from 'globalConst/gigya-const';

import { GIGYA_SCREENSET_MOBILE_VIEW_BREAKPOINT } from 'globalConst/gigya-const';
import { gigyaRouterActions, gigyaActions } from './actions-const';

const store = getStore();

const TALPA_SCREEN_SET_REGISTER_LITE = 'Talpa-LiteRegistration';
const TALPA_SCREEN_SET_PROFILE_UPDATE = 'Talpa-ProfileUpdate';

const SCREEN_SET_ROUTES = {
  inloggen: {
    screenName: 'inloggen',
  },
  connect: {
    screenName: 'connect',
  },
  'wachtwoord-vergeten': {
    screenName: 'wachtwoord-vergeten',
  },
  'wachtwoord-resetten': {
    screenName: 'wachtwoord-resetten',
  },
  'wachtwoord-wijzigen': {
    screenName: 'wachtwoord-wijzigen',
  },
  registreren: {
    screenName: 'registreren',
  },
  'hd-audio-registratie': {
    screenName: 'hd-audio-registratie',
  },
  registrerenlite: {
    screenName: 'gigya-optin-screen',
    screenSet: TALPA_SCREEN_SET_REGISTER_LITE,
    isAvailableAfterLoggedIn: true,
  },
  registerenLiteSuccess: {
    screenName: 'gigya-optin-confirmed-screen',
    screenSet: TALPA_SCREEN_SET_REGISTER_LITE,
    isAvailableAfterLoggedIn: true,
  },
  profiel: {
    screenName: 'gigya-update-profile-screen',
    screenSet: TALPA_SCREEN_SET_PROFILE_UPDATE,
    isAvailableAfterLoggedIn: true,
  },
};

const TALPA_MODAL_SCREENS = [
  SCREEN_SET_ROUTES.inloggen.screenName,
  SCREEN_SET_ROUTES.registreren.screenName,
  SCREEN_SET_ROUTES.connect.screenName,
  SCREEN_SET_ROUTES['wachtwoord-vergeten'].screenName,
  SCREEN_SET_ROUTES['wachtwoord-resetten'].screenName,
  SCREEN_SET_ROUTES['wachtwoord-wijzigen'].screenName,
];

function findScreenForLocation(location) {
  const hash = location.hash.replace('#', '');
  return SCREEN_SET_ROUTES[hash];
}

function browseToScreen(screenName) {
  const pathname = Object.keys(SCREEN_SET_ROUTES).reduce((result, routeScreen) => {
    const path = SCREEN_SET_ROUTES[routeScreen].screenName === screenName ? `#${routeScreen}` : result;
    return path;
  }, '#');

  const currentPath = history.location.pathname;

  if (pathname === currentPath) {
    return;
  }

  if (location.search.includes(`?account-action=${GIGYA_ACCOUNT_ACTION.RESET_PASSWORD}`)) {
    return;
  }

  history.push(pathname);
  if (pathname === '#') {
    removeHash();
  }
}

export function handleBeforeScreenLoad(event) {
  const {
    gigyaModal: { currentScreen },
  } = store.getState();
  const { nextScreen } = event;

  if (nextScreen !== currentScreen) {
    browseToScreen(nextScreen);
    setBodyScroll(false);
    store.dispatch({
      type: gigyaRouterActions.GIGYA_SCREEN_OPENED,
      screen: nextScreen,
    });
  }
}

export function handleAfterSubmit(event) {
  const { response } = event;
  /*
   ** Errorcode 206001:
   ** Error message: Account pending registration
   ** Description: A method has been called that performs social login,
   ** but the registration process has not been finalized,
   ** or a required field is missing from the user profile or data.
   ** See https://developers.gigya.com/display/GD/Response+Codes+and+Errors+REST for all Gigya response codes
   */

  if (response.errorCode !== 0 && response.errorCode !== '206001') {
    return;
  }

  store.dispatch(updateProfile(parseAccountInfo(response)));
}

export function handleHide(event) {
  // Push history als de close vanuit Gigya komt. De reason "canceled" betekent
  // dat we zelf closeScreen aanroepen. In het geval van ESC en kruisje krijg
  // je respectivielijk undefined en "finished".
  if (event.reason !== 'canceled') {
    browseToScreen(null);
  }
  setBodyScroll(true);
  store.dispatch({ type: gigyaRouterActions.GIGYA_SCREEN_CLOSED });
}

function closeScreen() {
  gigya.hideScreenSet({
    screenSet: TALPA_SCREEN_SET_PROFILE_UPDATE,
  });
}

// Respond to history changes, also takes care of initial screen loading
export function updateGigyaScreenRouter() {
  return (dispatch, getState) => {
    const { user } = getState();
    const screen = findScreenForLocation(history.location);
    if (screen && screen.screenName === SCREEN_SET_ROUTES.connect.screenName && !user.isLoggedIn) {
      if (window.innerWidth > GIGYA_SCREENSET_MOBILE_VIEW_BREAKPOINT) {
        store.dispatch(showTalpaGigyaModal(GIGYA_SCREENSET.REGISTRATION_LOGIN, GIGYA_SCREENSET.LOGIN_SCREEN));
      }
    } else if (screen && screen.screenName === SCREEN_SET_ROUTES['hd-audio-registratie'].screenName) {
      store.dispatch(setUserHDPreference(true, false, user.isLoggedIn));
      if (!user.isLoggedIn) {
        store.dispatch(showTalpaGigyaModal(GIGYA_SCREENSET.REGISTRATION_LOGIN, GIGYA_SCREENSET.LOGIN_SCREEN, true));
      }
      removeHash();
    } else if (
      !screen ||
      (user.isLoggedIn && !screen.isAvailableAfterLoggedIn) ||
      (!user.isLoggedIn && screen.isAvailableAfterLoggedIn)
    ) {
      closeScreen();
    } else if (TALPA_MODAL_SCREENS.includes(screen.screenName)) {
      store.dispatch(showTalpaGigyaModal());
    } else {
      // openScreen(screen);
    }
  };
}

history.listen((location, action) => {
  // De PUSH state wordt al door Gigya goed gezet, wij hoeven
  // er alleen maar voor te zorgen dat de terugweg goed gaat
  // aangezien Gigya zelf niets met browser history doet.
  if (action === 'POP') {
    store.dispatch(updateGigyaScreenRouter());
  }
});

export const navigateToLoginScreen = () => {
  store.dispatch(showTalpaGigyaModal(GIGYA_SCREENSET.REGISTRATION_LOGIN, GIGYA_SCREENSET.LOGIN_SCREEN));
  return { type: gigyaActions.ATTEMPT_LOGIN };
};

export const navigateToRegisterScreen = () => {
  store.dispatch(showTalpaGigyaModal(GIGYA_SCREENSET.REGISTRATION_LOGIN, GIGYA_SCREENSET.REGISTER_SCREEN));
  return { type: gigyaRouterActions.ATTEMPT_NAVIGATE_REGISTER };
};

export const navigateToRegisterLiteScreen = () => {
  store.dispatch(showTalpaGigyaModal(GIGYA_SCREENSET.LITE_REGISTRATION));
  return { type: gigyaRouterActions.ATTEMPT_NAVIGATE_REGISTER_LITE };
};

export const navigateToRegisterLiteSuccessScreen = () => {
  store.dispatch(showTalpaGigyaModal(GIGYA_SCREENSET.LITE_REGISTRATION));
  return { type: gigyaRouterActions.ATTEMPT_NAVIGATE_REGISTER_LITE };
};

export const navigateToEditProfileScreen = () => {
  store.dispatch(showTalpaGigyaModal(GIGYA_SCREENSET.PROFILE));
  return { type: gigyaRouterActions.ATTEMPT_NAVIGATE_EDIT };
};

onVendorLoaded('gigya')
  .then(() => {
    window.gigya.socialize.addEventHandlers({
      onLogin: (response) => {
        store.dispatch(login(response));
      },
      onLogout: () => {
        if (store.getState().user.isLoggedIn) {
          store.dispatch(logout());
        }
      },
    });
  })
  .catch((error) => logger.error(error));

// Filter invalid gigya path on boot
// Initial screen loading is done in updateGigyaScreenRouter
export function bootGigyaScreenRouter() {
  return () => {
    if (window.location.hash.substr(1) === 'show-consent-manager' && typeof __tcfapi === 'function') {
      __tcfapi('showConsentManager', 2);
    }
    if (window.location.hash.substr(1) === 'optin' || window.location.hash.substr(1) === 'registrerenlite') {
      navigateToRegisterLiteScreen();
    }
    if (
      window.location.hash.substr(1) === 'optin-success' ||
      window.location.hash.substr(1) === 'registerenLiteSuccess'
    ) {
      navigateToRegisterLiteSuccessScreen();
    }
    if (window.location.hash.substr(1) === SCREEN_SET_ROUTES.connect.screenName) {
      store.dispatch(setModalStandaloneOpen());
    }
    const screen = findScreenForLocation(history.location);
    if (!screen) {
      removeHash();
    }
  };
}
